module.exports = __webpack_public_path__ + "static/media/define_girl.07ec8e82.png";